import { useUserStore } from '@/stores/user_store'
import type { ResourceAccessRole } from '@/models/resource_access_role'

/**
 * Reactive permission checks against the signed-in user's Keycloak client
 * roles (`useUserStore().userInfo.roles`). Deny-by-default: `hasRole`
 * returns `false` while `userInfo` is `null` (not yet bootstrapped, or
 * logged out), so gated UI never flashes controls the user doesn't have.
 *
 * A plain `.includes()` check — the backend already expands `admin` into
 * the full explicit role list on `/auth/me`, so there is no separate
 * "admin bypasses everything" special case here.
 */
export function usePermissions() {
  const userStore = useUserStore()

  function hasRole(role: ResourceAccessRole): boolean {
    return userStore.userInfo?.roles.includes(role) ?? false
  }

  return { hasRole }
}
